import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../api";

function StatCard({ titre, valeur }) {
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "14px",
        padding: "18px",
        boxShadow: "0 2px 8px rgba(0,0,0,.08)"
      }}
    >
      <div
        style={{
          fontSize: "14px",
          color: "#666"
        }}
      >
        {titre}
      </div>

      <div
        style={{
          fontSize: "28px",
          fontWeight: "700",
          marginTop: "8px"
        }}
      >
        {valeur}
      </div>
    </div>
  );
}

export default function ImmeubleDetail() {
  const { id } = useParams();

  const [immeuble, setImmeuble] = useState(null);
  const [appartements, setAppartements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);

  const [creatingAppartement, setCreatingAppartement] = useState(false);

  const [appartementForm, setAppartementForm] = useState({
    numero: "",
    type_logement: "appartement standard",
    prix_nuitee: "",
    capacite: 2
  });

  const [form, setForm] = useState({
    nom: "",
    adresse: "",
    ville: "",
    pays: "",
    latitude: "",
    longitude: "",
    telephone: "",
    email: ""
  });


  useEffect(() => {
    load();
  }, [id]);

  const load = async () => {
    try {
      const [immeubleRes, appartementsRes] = await Promise.all([
        api.get(`/immeubles/${id}`),
        api.get(`/immeubles/${id}/appartements`)
      ]);

      setImmeuble(immeubleRes.data);
      setForm(immeubleRes.data);
      setAppartements(appartementsRes.data);

    } catch (err) {
      console.error("Erreur chargement immeuble:", err);
    } finally {
      setLoading(false);
    }
  };

  const total = appartements.length;

  const libres = appartements.filter(
    a => a.statut_reel === "libre"
  ).length;

  const reserves = appartements.filter(
    a => a.statut_reel === "reserve"
  ).length;

  const occupes = appartements.filter(
    a => a.statut_reel === "occupe"
  ).length;

  const tauxOccupation =
    total > 0
      ? Math.round((occupes / total) * 100)
      : 0;

  const saveImmeuble = async () => {
    try {

      const res = await api.put(
        `/immeubles/${id}`,
        form
      );

      setImmeuble(res.data);
      setEditing(false);

    } catch (err) {
      console.error(err);
      alert("Erreur de sauvegarde");
    }
  };

  const createAppartement = async () => {
    try {

      await api.post("/appartements", {
        ...appartementForm,
        immeuble_id: Number(id),
        est_louable: true
      });

      setCreatingAppartement(false);

      setAppartementForm({
        numero: "",
        type_logement: "appartement standard",
        prix_nuitee: "",
        capacite: 2
      });

      await load();

    } catch (err) {
      console.error(err);
      alert("Erreur lors de la création du logement");
    }
  };

  if (loading) {
    return (
      <div style={{ padding: 20 }}>
        Chargement...
      </div>
    );
  }

  return (
    <div style={{ padding: 20 }}>

      {/* HEADER */}
      <div style={{ marginBottom: 25 }}>
        <h1
          style={{
            marginBottom: 10,
            fontSize: "30px"
          }}
        >
          🏢 {immeuble?.nom}
        </h1>

        <p
          style={{
            margin: "4px 0",
            color: "#666"
          }}
        >
          📍 {immeuble?.adresse}
        </p>

        <p
          style={{
            margin: "4px 0",
            color: "#666"
          }}
        >
          🌍 {immeuble?.ville}, {immeuble?.pays}
        </p>

        <div
          style={{
            display: "flex",
            gap: 10,
            marginTop: 12
          }}
        >
          {immeuble?.latitude && immeuble?.longitude && (
            <button
              onClick={() =>
                window.open(
                  `https://www.google.com/maps?q=${immeuble.latitude},${immeuble.longitude}`,
                  "_blank"
                )
              }
              style={{
                padding: "10px 16px",
                borderRadius: "10px",
                border: "1px solid #ddd",
                cursor: "pointer",
                background: "#fff"
              }}
            >
              📍 Voir sur la carte
            </button>
          )}

          <button
            onClick={() => setEditing(true)}
            style={{
              padding: "10px 16px",
              borderRadius: "10px",
              border: "1px solid #ddd",
              cursor: "pointer"
            }}
          >
            ✏️ Modifier
          </button>

          <button
            onClick={() => setCreatingAppartement(true)}
            style={{
              padding: "10px 16px",
              borderRadius: "10px",
              border: "1px solid #ddd",
              cursor: "pointer"
            }}
          >
            ➕ Ajouter un logement
          </button>

        </div>
      </div>

      {/* STATISTIQUES */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(180px,1fr))",
          gap: "15px",
          marginBottom: "25px"
        }}
      >
        <StatCard titre="🏠 Total logements" valeur={total} />
        <StatCard titre="🟢 Libres" valeur={libres} />
        <StatCard titre="🟡 Réservés" valeur={reserves} />
        <StatCard titre="🔴 Occupés" valeur={occupes} />
      </div>

      <div
        style={{
          marginBottom: "25px",
          fontWeight: "bold",
          fontSize: "18px"
        }}
      >
        📈 Taux d'occupation : {tauxOccupation}%
      </div>

      {editing && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "14px",
              padding: "20px",
              width: "95%",
              maxWidth: "700px",
              maxHeight: "90vh",
              overflowY: "auto"
            }}
          >
            <h2>✏️ Modifier l'immeuble</h2>

            <div style={{ display: "grid", gap: 12 }}>

              <input
                placeholder="Nom"
                value={form.nom || ""}
                onChange={(e) =>
                  setForm({
                    ...form,
                    nom: e.target.value
                  })
                }
              />

              <input
                placeholder="Adresse"
                value={form.adresse || ""}
                onChange={(e) =>
                  setForm({
                    ...form,
                    adresse: e.target.value
                  })
                }
              />

              <input
                placeholder="Ville"
                value={form.ville || ""}
                onChange={(e) =>
                  setForm({
                    ...form,
                    ville: e.target.value
                  })
                }
              />

              <input
                placeholder="Pays"
                value={form.pays || ""}
                onChange={(e) =>
                  setForm({
                    ...form,
                    pays: e.target.value
                  })
                }
              />

              <input
                placeholder="Latitude"
                value={form.latitude || ""}
                onChange={(e) =>
                  setForm({
                    ...form,
                    latitude: e.target.value
                  })
                }
              />

              <input
                placeholder="Longitude"
                value={form.longitude || ""}
                onChange={(e) =>
                  setForm({
                    ...form,
                    longitude: e.target.value
                  })
                }
              />

              <input
                placeholder="Téléphone"
                value={form.telephone || ""}
                onChange={(e) =>
                  setForm({
                    ...form,
                    telephone: e.target.value
                  })
                }
              />

              <input
                placeholder="Email"
                value={form.email || ""}
                onChange={(e) =>
                  setForm({
                    ...form,
                    email: e.target.value
                  })
                }
              />

            </div>

            <div
              style={{
                marginTop: 20,
                display: "flex",
                justifyContent: "flex-end",
                gap: 10
              }}
            >
              <button
                onClick={() => setEditing(false)}
              >
                Annuler
              </button>

              <button
                onClick={saveImmeuble}
              >
                Enregistrer
              </button>
            </div>
          </div>
        </div>
      )}

      {creatingAppartement && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "14px",
              padding: "20px",
              width: "95%",
              maxWidth: "600px"
            }}
          >
            <h2>🏠 Nouveau logement</h2>

            <div
              style={{
                display: "grid",
                gap: "12px"
              }}
            >
              <input
                placeholder="Numéro"
                value={appartementForm.numero}
                onChange={(e) =>
                  setAppartementForm({
                    ...appartementForm,
                    numero: e.target.value
                  })
                }
              />

              <select
                value={appartementForm.type_logement}
                onChange={(e) =>
                  setAppartementForm({
                    ...appartementForm,
                    type_logement: e.target.value
                  })
                }
              >
                <option value="chambre">
                  Chambre
                </option>

                <option value="appartement standard">
                  Appartement standard
                </option>

                <option value="appartement premium">
                  Appartement premium
                </option>

                <option value="suite">
                  Suite
                </option>
              </select>

              <input
                type="number"
                placeholder="Prix nuitée"
                value={appartementForm.prix_nuitee}
                onChange={(e) =>
                  setAppartementForm({
                    ...appartementForm,
                    prix_nuitee: e.target.value
                  })
                }
              />

              <input
                type="number"
                placeholder="Capacité"
                value={appartementForm.capacite}
                onChange={(e) =>
                  setAppartementForm({
                    ...appartementForm,
                    capacite: e.target.value
                  })
                }
              />
            </div>

            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px"
              }}
            >
              <button
                onClick={() =>
                  setCreatingAppartement(false)
                }
              >
                Annuler
              </button>

              <button
                onClick={createAppartement}
              >
                Créer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* TABLEAU */}
      <div
        style={{
          background: "#fff",
          borderRadius: "14px",
          padding: "15px",
          boxShadow: "0 2px 8px rgba(0,0,0,.08)",
          overflowX: "auto"
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse"
          }}
        >
          <thead>
            <tr>
              <th style={thStyle}>Numéro</th>
              <th style={thStyle}>Type</th>
              <th style={thStyle}>Capacité</th>
              <th style={thStyle}>Prix</th>
              <th style={thStyle}>Statut</th>
            </tr>
          </thead>

          <tbody>
            {appartements.map((a) => (
              <tr key={a.id}>
                <td style={tdStyle}>{a.numero}</td>

                <td style={tdStyle}>
                  {a.type_logement}
                </td>

                <td style={tdStyle}>
                  {a.capacite}
                </td>

                <td style={tdStyle}>
                  {a.prix_nuitee
                    ? `${a.prix_nuitee}$`
                    : "-"}
                </td>

                <td style={tdStyle}>
                  {a.statut_reel === "occupe" &&
                    "🔴 Occupé"}

                  {a.statut_reel === "reserve" &&
                    "🟡 Réservé"}

                  {a.statut_reel === "libre" &&
                    "🟢 Libre"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}

const thStyle = {
  textAlign: "left",
  padding: "12px",
  borderBottom: "1px solid #ddd"
};

const tdStyle = {
  padding: "12px",
  borderBottom: "1px solid #eee"
};